import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/1.jpg';
// import p2 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/2.jpg';
// import p3 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/3.jpg';
// import p4 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/4.jpg';
// import p5 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/5.jpg';
// import p6 from 'assests/Photos/Clubs/EkBharatClub/2024/Thematic/6.jpg';

// import Ecoclub2023 from 'views/EnvironmentDay2023/Ecoclub2023';


import { Typography } from '@mui/material';
import Container from 'components/Container';
// import Sidebar2023 from './Sidebar2023';

import Sidebar2024 from '../EkBharat2023/components/Sidebar2024';
import Archive2023 from '../EkBharat2023/components/Sidebar2023/Archive2023';
import Sidebar2025 from '../EkBharat2023/components/Sidebar2025';



const HarGhar2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Harghar/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Harghar/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Harghar/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/association/EkBharatClub/Harghar/4.webp`;
  


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    }
      
  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h5' align='center' >
      Independence Day-Har Ghar Tiranga 
                                </Typography>
                                <br></br>
                                {/* <Typography variant='h7' align='justify' >
                                Class 4: Diversity Montage
                                Class 5: Continental Montage 

                                </Typography> */}
        {/* <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 6 to 8  &  Date: 15 August 2024
        </Typography> */}
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “Knowing law is understanding the difference between knowing what is right to do, and what you have to right to do”-Potter Stewart

<br/>
        </Typography> */}
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
       Independence Day was celebrated with great enthusiasm and patriotic spirit at school. Students showcased their creativity through drawings, writings, and vibrant displays on the theme of Independence Day, which were proudly arranged on class bulletin boards. These activities fostered teamwork, artistic expression, and a deep sense of national pride.  
        <br></br>
        As part of the CBSE Har Ghar Tiranga campaign, students participated in flag-making and poster-making activities. Under the guidance of teachers, they crafted the Indian tricolour and learned the significance of its colours and the Ashoka Chakra. The next day, they took part in a spirited rally within the school premises, waving their handmade flags and chanting patriotic slogans, spreading a message of unity and love for the nation.
        <br></br>
        The main celebration began with a solemn flag hoisting ceremony followed by the national anthem. Students then participated in a well-coordinated march past and a cultural programme featuring patriotic songs, dances, and a mime performance. The event concluded with an inspiring message from the Principal, while families across the community also joined in the celebration, adding to the patriotic fervour of the day. 
        <br></br>
        </Typography>
      </Box>
      {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
       “Diversity is not about how we differ, Diversity is about embracing one another’s uniqueness”

<br/>
        </Typography> */}

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <Sidebar2025/>
             </Box>

             <Box marginBottom={4}>
               <Archive2023 />
             </Box>

    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default HarGhar2025;